import { MIN_SUB_MENU_ITEMS_SIZE } from '../constants/menu'

import { useSubMenu } from './useSubMenu'

export function useHasSubMenuItems() {
  const subMenu = useSubMenu()

  return subMenu?.items?.length >= MIN_SUB_MENU_ITEMS_SIZE
}
